import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { API, graphqlOperation } from 'aws-amplify'

const operation = `query GetTenant($pk: ID!, $sk: String) {
    getTenant(pk: $pk, sk: $sk) {
        ... on TenantPopulation {
            estimated
            changedAt
            __typename
        }
        ... on TenantAcknowledgements {
            __typename
            pk
            sk
            d1
            building
            tenant
            acknowledgements {
                acknowledgedBy {
                    pk
                    firstName
                    lastName
                    email
                }
                active
                declined
                timestamp
            }
        }
    }
}`

export const useShowTenantConfigurator = () => {
    const [isAcknowledged, setIsAcknowledged] = useState(false)
    const [population, setPopulation] = useState(null)
    const tenantAdmin = useSelector((state) => state.app.user?.roles?.includes('TENANT_ADMIN'))
    const tenant = useSelector((state) => state.app.tenant)
    const [loading, setLoading] = useState(true)

    const handler = (_data) => {
        setIsAcknowledged(_data.find(d => d.__typename === 'TenantAcknowledgements'))
        setPopulation(_data.find(d => d.__typename === 'TenantPopulation'))
        setLoading(false)
    }

    const fetchData = async () => {
        if (tenantAdmin && tenant) {
            try {
                setLoading(true)
                const response = await API.graphql(graphqlOperation(operation, { pk: tenant.pk, sk: 'TENANT' }))
                handler(response.data.getTenant)
            } catch (err) {
                console.error(err)
                setLoading(false)
            }
        }
    }

    const refresh = () => {
        fetchData()
    }

    useEffect(() => {
        fetchData()
    }, [tenantAdmin, tenant])

    return { isAcknowledged, population, loading, refresh }
}
